module.exports = __webpack_public_path__ + "static/media/calvary.8dbf1c45.svg";